import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Ribbon = ({
  color,
  children,
  className,
  position,
  variant,
  style
}) => {
  let classes = `${className} ribbon-wrapper ribbon-variant-${variant} ribbon-position-${position} ${color}`;
  return (
    <div className={classes} style={style}>
      <div className="ribbon-content">{children}</div>
    </div>
  );
}


Ribbon.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  position: PropTypes.string,
  variant: PropTypes.string,
  style: PropTypes.object
};


Ribbon.defaultProps = {
  className: '',
  color: 'red',
  children: null,
  position: 'default',
  variant: 'default',
  style: {}
};

export default Ribbon;
